import React,{useMemo} from "react";
import css from "./TerminalView.module.css";
import CopyButton from "./CopyButton/CopyButton";
import {prompt0} from "Assets";


export default function TerminalView(props){
    const lines=useMemo(()=>mendLines(props.lines),[props.lines]);
    return (
        <div className={`${css.terminalview} ${props.className||""}`} style={props.style}>
            <CopyButton text={lines.filter(line=>!line.isComment).map(({text})=>text||"").join(" ")}/>
            {lines.map((line,i)=>{
                const keywords=[...statics.keywords];
                line.keywords&&keywords.push(...line.keywords);
                const {isComment}=line;
                return (
                    <p key={i} className={css.line} iscomment={isComment?"":undefined}>
                        {(!isComment)&&
                            <img className={css.indicator} src={prompt0(majorColor)}/>
                        }
                        {line.text?.split(" ").map(word=>(
                            <span 
                                key={word} 
                                className={keywords?.includes(word)?css.keyword:undefined}
                            >{word} </span>
                        ))}
                    </p>
                ) 
            })}
        </div>
    )
}

const statics={
    keywords:["npm","yarn","install","npx","create-vritra-app","cordova","browser@7"],
}

const mendLines=(lines)=>{
    lines.forEach((line,i)=>{
        const isText=typeof(line)==="string";
        if(isText){lines[i]={text:line.trim()}}
        else{
            line.text=line.text?.trim();
        }
        const text=isText?line:line.text;
        if(text.startsWith("#")){
            lines[i].isComment=true;
        }
    });
    return lines;
}
